module.exports = __webpack_public_path__ + "img/01顶部banner@2x.8bff292f.webp";